/** One row of a colour select: the stored value, its name and its swatch. */
export interface ColourOption {
  label: string;
  value: string;
  hex: string;
}

/**
 * The option's label. A stored value that is not in the list shows as its raw
 * value rather than blank — a retired or mistyped colour should be visible,
 * not silently look like "no colour chosen".
 */
export function colourLabel(options: ColourOption[], value?: string | null): string {
  if (!value) return '';
  return options.find((o) => o.value === value)?.label ?? value;
}

/** The option's swatch; transparent for a value not in the list. */
export function colourHex(options: ColourOption[], value?: string | null): string {
  return options.find((o) => o.value === value)?.hex ?? 'transparent';
}
